// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".span-box2[data-v-d398a214] {\n  font-family: Microsoft YaHei;\n  margin-left: 25px;\n  margin-top: 12px;\n}\n.mleft[data-v-d398a214] {\n  margin-left: 50px;\n}\n.editBox[data-v-d398a214] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: baseline;\n      -ms-flex-align: baseline;\n          align-items: baseline;\n}\n", ""]);
// Exports
module.exports = exports;
